module.exports = __webpack_public_path__ + "static/media/main_nav_arrow_green.31994637.svg";